import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateNominationMarketplaceOffer: (
  fetchContext: FetchContext,
  nominationId: number,
  marketplaceOfferUrl?: string,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, marketplaceOfferUrl, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/marketplace-offer`, {
    method: 'PUT',
    body: JSON.stringify({ marketplaceOfferUrl }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update nomination marketplace offer'));
